import React from 'react';
import styled from 'styled-components';

import rehireIllustration from './rehire_illustration.svg';

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledContent = styled.div`
  margin-left: ${props => props.theme.spacing[2]};
  width: 60%;
`;

const RehireJobDescription = () => (
  <StyledWrapper>
    <div>
      <img src={rehireIllustration} alt="Rehire job" />
    </div>
    <StyledContent>
      <h6>Rehire</h6>
      <p>Select from a customised pool of Weployees who have worked for your organisation in the past. </p>
      <p>
        Hire Weployees familiar to your organisation<br />
        Reduce onboarding time & costs<br />
        Select your preferred candidate within 24 hours
      </p>
    </StyledContent>
  </StyledWrapper>
);

export default RehireJobDescription;
